import { createAsyncComponent, withInstall } from '@mts-fe/utils';
import _BaseBadge from './src/BaseBadge.vue';
import _BaseEmpty from './src/BaseEmpty.vue';
import _BaseInputRange from './src/BaseInputRange.vue';
import _BasePanel from './src/BasePanel.vue';
import _BaseParagraph from './src/BaseParagraph.vue';
import _BaseProgress from './src/BaseProgress.vue';
import _BaseTag from './src/BaseTag.vue';
import _DataList from './src/DataList.vue';
import _DetailPanel from './src/DetailPanel.vue';
import _DictTag from './src/DictTag.vue';
import _EditableForm from './src/EditableForm.vue';
import _MTabs from './src/MTabs.vue';
import _PreviewImage from './src/PreviewImage.vue';
import _ReadonlyForm from './src/ReadonlyForm.vue';
import _ReadonlyNumber from './src/ReadonlyNumber.vue';
import _ReportStatistics from './src/ReportStatistics.vue';
import _ScanBar from './src/ScanBar.vue';
import _SearchForm from './src/SearchForm.vue';
import _VirtualKeyboard from './src/VirtualKeyboard.vue';

export * from './src/BaseInputRange.vue';
export * from './src/BaseModalForm.vue';
export * from './src/BaseTag.vue';
export * from './src/DataList.vue';
export * from './src/Draggable';
export * from './src/ScanBar.vue';
export * from './src/VirtualKeyboard.vue';
export type { FormActionType } from '@mts/components/Form';
export const BaseModalForm = createAsyncComponent(() => import('./src/BaseModalForm.vue'));
export const BaseModalTable = createAsyncComponent(() => import('./src/BaseModalTable.vue'));
export const BaseModalCard = createAsyncComponent(() => import('./src/BaseModalCard.vue'));
export const AsyncTaskModal = createAsyncComponent(() => import('./src/AsyncTaskModal.vue'));
export const ExportTaskModal = createAsyncComponent(() => import('./src/ExportTaskModal.vue'));
export const BaseBadge = withInstall(_BaseBadge);
export const BaseEmpty = withInstall(_BaseEmpty);
export const BaseTag = withInstall(_BaseTag);
export const DictTag = withInstall(_DictTag);
export const PreviewImage = withInstall(_PreviewImage);
export const MTabs = withInstall(_MTabs);
export const ScanBar = withInstall(_ScanBar);
/** @deprecated 废弃，不建议使用 */
export const SearchForm = withInstall(_SearchForm);
export const BasePanel = withInstall(_BasePanel);
export const BaseParagraph = withInstall(_BaseParagraph);
export const DataList = withInstall(_DataList);
export const DetailPanel = withInstall(_DetailPanel);
export const BaseProgress = withInstall(_BaseProgress);
export const TaskProgress = createAsyncComponent(() => import('./src/TaskProgress.vue'));
export const BasePopover = createAsyncComponent(() => import('./src/BasePopover.vue'));
/** @deprecated 废弃，建议直接使用SimpleForm */
export const EditableForm = withInstall(_EditableForm);
export const ReadonlyNumber = withInstall(_ReadonlyNumber);
export const ReadonlyForm = withInstall(_ReadonlyForm);
export const BaseInputRange = withInstall(_BaseInputRange);
export const ReportStatistics = withInstall(_ReportStatistics);
/** @deprecated 废弃，不建议使用 */
export const VirtualKeyboard = withInstall(_VirtualKeyboard);

export const MTS_COLOR_KEYS = [
  'temp',
  'check',
  'todo',
  'pre_doing',
  'doing',
  'pre_done',
  'pub',
  'done',
  'close',
  'cancel',
  'error',
  'mian_liao',
  'fu_liao',
] as const;
export type MColor = (typeof MTS_COLOR_KEYS)[number];
